 function showToast(type, title, subtitle, content, delay) {
    if (!$('#toast-container').length) {
    $('body').append(
    '<div id="toast-container" aria-live="polite" aria-atomic="true" style="position: fixed; top: 0; right: 0; z-index: 1055;">'
    + '<div id="toast-wrapper"></div></div>'
    );
}

    var types = {
    info:    'bg-info text-white',
    success: 'bg-success text-white',
    warning: 'bg-warning text-white',
    danger:  'bg-danger text-white'
};
    if (type === 'error') type = 'danger';
    if (type === 'warn')  type = 'warning';
    var headerClasses = types[type] || '';
    var subtitleClass = headerClasses ? 'text-white' : 'text-muted';
    var titleText    = title || 'Notice!';
    var subtitleText = subtitle || '';
    var contentText  = content || '';
    var delayMs      = delay || 3000;

    var toastHtml =
    '<div class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-delay="' + delayMs + '">' +
    '<div class="toast-header ' + headerClasses + '">' +
    '<strong class="mr-auto">' + titleText + '</strong>' +
    '<small class="' + subtitleClass + '">' + subtitleText + '</small>' +
    '<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
    '<span aria-hidden="true" ' + (headerClasses ? 'class="text-white"' : '') + '>&times;</span>' +
    '</button>' +
    '</div>' +
    '<div class="toast-body">' + contentText + '</div>' +
    '</div>';

    $('#toast-wrapper').append(toastHtml);
    $('#toast-wrapper .toast:last').toast('show');
}

 window.showToast = showToast;